import { Component } from '@angular/core';
import { footerSocialData, footerSocialIconMap } from './footer-social';

@Component({
  selector: 'app-footer-social',
  templateUrl: './footer-social.component.html',
  styleUrls: ['./footer-social.component.scss'],
})
export class FooterSocialComponent {
  public readonly iconMap = footerSocialIconMap;
  public readonly items = footerSocialData;
}
